'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _setImmediate2 = require('babel-runtime/core-js/set-immediate');

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactJsonschemaForm = require('react-jsonschema-form');

var _reactJsonschemaForm2 = _interopRequireDefault(_reactJsonschemaForm);

var _utils = require('react-jsonschema-form/lib/utils');

var _validate = require('./validate');

var _validate2 = _interopRequireDefault(_validate);

var _whatFieldWasChanged = require('../../utils/whatFieldWasChanged');

var _whatFieldWasChanged2 = _interopRequireDefault(_whatFieldWasChanged);

var _getClearedFields = require('../../utils/getClearedFields');

var _getClearedFields2 = _interopRequireDefault(_getClearedFields);

var _getFilterFields = require('../../utils/getFilterFields');

var _getFilterFields2 = _interopRequireDefault(_getFilterFields);

var _setUIProperty = require('../../utils/setUIProperty');

var _setUIProperty2 = _interopRequireDefault(_setUIProperty);

var _setItemsInSchema = require('../../utils/setItemsInSchema');

var _setItemsInSchema2 = _interopRequireDefault(_setItemsInSchema);

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setState(instance, state, callback) {
  var safeRenderCompletion = instance.props.safeRenderCompletion;
  // фикс бага с тем, что каретка в телефоном инпуте не встает на место после +7
  // https://github.com/perxteam/azgaz-ring/issues/3408

  var errorSchemaKeys;
  try {
    errorSchemaKeys = (0, _keys2.default)(state.errorSchema);
  } catch (e) {
    errorSchemaKeys = [];
  }
  errorSchemaKeys.forEach(function (key) {
    if (key.startsWith('phoneInput') && state.errorSchema[key].__errors.length === 0) {
      state.errorSchema[key] = {};
    }
  });
  if (safeRenderCompletion) {
    instance.setState(state, callback);
  } else {
    instance.setState(state);
    (0, _setImmediate3.default)(callback);
  }
} /* eslint-disable */


var initialContext = {
  formControlState: {},
  setTouched: function setTouched(id) {
    this.formControlState[id] = 'touched';
  },
  setDirty: function setDirty(id) {
    this.formControlState[id] = 'dirty';
  },
  isTouched: function isTouched(id) {
    return this.formControlState[id] === 'touched';
  },
  isPristine: function isPristine(id) {
    return this.formControlState[id] == null;
  },
  isDirty: function isDirty(id) {
    return this.formControlState[id] === 'dirty';
  },
  cssPrefix: 'form-widget'
};

var JSONSchemaForm = function (_Form) {
  (0, _inherits3.default)(JSONSchemaForm, _Form);

  function JSONSchemaForm(props) {
    (0, _classCallCheck3.default)(this, JSONSchemaForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (JSONSchemaForm.__proto__ || (0, _getPrototypeOf2.default)(JSONSchemaForm)).call(this, props));

    _this.wasInitiated = false;

    _this.resetForm = function () {
      var formData = _this.state.formData;

      var newData = {};

      var preset = _this.props.preset;

      var fields = [];

      initialContext.formControlState = {};

      (0, _keys2.default)(formData).forEach(function (key) {
        newData[key] = undefined;
      });

      (0, _keys2.default)(preset).forEach(function (key) {
        newData[key] = preset[key];

        var fieldsToClear = (0, _getClearedFields2.default)(_this.props.formId, key);

        fieldsToClear.forEach(function (f) {
          fields.push(f);
        });
      });

      _this.setState({ formData: newData, isLoading: false, current: 'form', status: 'initial' }, function () {
        if (fields.length > 0) {
          _this.refreshDataSourceFields(fields);
        }
      });
    };

    _this.getAllClearedFields = function (baseField) {
      /**
       *  Алгоритм для перезагрузки датасорса:
       *    1. При изменении данных проверить есть ли у изменённого поля зависимые поля
       *    2. У каждого зависимого поля необходимо
       *    2.1. Убрать существующее значение
       *    2.2. Аналогичным образом проверить есть ли у него зависимые поля
       *    2.3. GOTO пункт №2
      */
      var fieldsToClear = [];

      var baseFieldsToClear = (0, _getClearedFields2.default)(_this.props.formId, baseField);
      baseFieldsToClear.forEach(function (field) {
        fieldsToClear.push(field);

        var additionalFieldsToClear = _this.getAllClearedFields(field);
        additionalFieldsToClear.map(function (additionalField) {
          fieldsToClear.push(additionalField);
        });
      });

      return fieldsToClear;
    };

    _this.onChange = function (formData) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { validate: false };
      var forceFieldChanged = arguments[2];
      var schema = _this.props.schema;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {

        for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(formData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var entry = _step.value;

          var key = entry[0];
          var value = entry[1];

          if (!!value && !!value.trimLeft) {
            formData[key] = value.trimLeft();
          }

          /**
           * перезаписываем значение false как undefined,
           * т.к. jsonschema (обновление до v.1.4.0 не помогло) не валидирует значение false как ошибку,
           * когда поле обязательно для чекбокса
           */
          if (schema.properties[key].type === 'boolean' && value === false) {
            formData[key] = undefined;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var wasChanged = (0, _whatFieldWasChanged2.default)(_this.state.formData, formData);

      var fieldsToClear = _this.getAllClearedFields(wasChanged || forceFieldChanged);
      fieldsToClear.forEach(function (f) {
        formData[f] = undefined;
      });

      var mustValidate = !_this.props.noValidate && (_this.props.liveValidate || options.validate);

      var state = { status: "editing", formData: formData };

      if (mustValidate) {
        var _this$validate = _this.validate(formData),
            errors = _this$validate.errors,
            errorSchema = _this$validate.errorSchema;

        state = (0, _extends3.default)({}, state, { errors: errors, errorSchema: errorSchema });
      }

      setState(_this, state, function () {
        if (_this.props.onChange) {
          _this.props.onChange(_this.state);
        }

        if (fieldsToClear.length > 0) {
          _this.refreshDataSourceFields(fieldsToClear);
        }
      });
    };

    _this.onSubmit = function (event) {
      event.preventDefault();

      if (_this.state.isLoading) {
        console.warn('Отправка данных уже производится');
        return;
      }

      if (_this.state.status === 'submitted') {
        console.warn('Отправка данных была произведена');
        return;
      }

      window.FormsServiceWidget.serverErrors = {};
      _this.refreshAllFields();

      _this.setState({
        status: 'submitted',
        isLoading: true,
        flatErrors: []
      }, function () {
        if (!_this.props.noValidate) {
          var idSchema = _this.state.idSchema;

          delete idSchema['$id'];

          (0, _keys2.default)(idSchema).forEach(function (field) {
            return initialContext.setTouched(field);
          });

          var _this$validate2 = _this.validate(_this.state.formData),
              errors = _this$validate2.errors,
              errorSchema = _this$validate2.errorSchema;

          if ((0, _keys2.default)(errors).length > 0) {
            setState(_this, { errors: errors, errorSchema: errorSchema, isLoading: false }, function () {
              if (_this.props.onError) {
                _this.props.onError(errors);
              } else {
                console.error('Form validation failed', errors);
              }
            });
            return;
          }
        }

        if (_this.props.onSubmit) {
          _this.props.onSubmit(_this.state).then(_this.onRequest.bind(_this)).catch(function () {
            _this.onErrorRequest([{ errors: ['К сожалению, отправка данных не удалась'] }]);
          });
        } else {
          _this.setState({ status: 'initial', errors: [], errorSchema: {}, isLoading: false });
        }
      });
    };

    _this.state = _this.getStateFromProps(props);
    return _this;
  }

  (0, _createClass3.default)(JSONSchemaForm, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      // Нужно блокировать кнопку если:
      // Изменился isLoading и теперь он true
      // Изменился status и теперь он submitted
      var isLoadingChanged = this.state.isLoading !== prevState.isLoading;
      var statusChanged = this.state.status !== prevState.status;

      if (isLoadingChanged) {
        this.disableButton(this.state.isLoading);

        return;
      }

      if (statusChanged) {
        this.disableButton(this.state.status === 'submitted');

        return;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(this.getStateFromProps(nextProps));
    }
  }, {
    key: 'refreshDataSourceFields',
    value: function refreshDataSourceFields(fields) {
      var _this2 = this;

      var formId = this.props.formId;


      var state = {};

      state.isLoading = true;

      setState(this, state, function () {
        var fieldsInSchema = fields.map(function (f) {
          return (0, _extends3.default)({}, _this2.state.schema.properties[f], { id: f });
        });

        var promises = fieldsInSchema.map(function (property) {
          var filters = {};
          var filterFields = (0, _getFilterFields2.default)(formId, property.id);

          filterFields.forEach(function (row) {
            filters[row.nameInDataSource] = _this2.state.formData[row.nameInForm] || '';
          });

          var params = (0, _keys2.default)(filters).map(function (key) {
            return key + '=' + filters[key];
          });

          var url = property.itemsDataSourceUrl + '?' + params.join('&');
          return fetch(url).then(function (response) {
            if (!response.ok) {
              return {
                property: property.id,
                type: property.type,
                values: []
              };
            }

            return response.json().then(function (json) {
              return {
                property: property.id,
                type: property.type,
                values: json
              };
            });
          }).catch(function (e) {
            return {
              property: property.id,
              type: property.type,
              values: []
            };
          });
        });

        _promise2.default.all(promises).then(function (datasources) {
          var clonedSchema = _ramda2.default.clone(_this2.props.schema);
          var clonedUISchema = _ramda2.default.clone(_this2.props.uiSchema);

          var data = _ramda2.default.clone(_this2.state.formData);

          datasources.forEach(function (ds) {
            var readOnlyState = false;

            if (ds.values.length === 0) {
              readOnlyState = true;
            } else if (ds.values.length === 1) {
              if (ds.type === 'array') {
                data[ds.property] = [ds.values[0]['id']];
              } else {
                data[ds.property] = ds.values[0]['id'];
              }
              // вызываем для запроса новых данных по данному полю
              _this2.onChange(data, {}, ds.property);
              readOnlyState = true;
            }
            clonedUISchema = (0, _setUIProperty2.default)(clonedUISchema, ds.property, 'ui:disabled', readOnlyState);

            (0, _setItemsInSchema2.default)(clonedSchema, ds);
          });

          _this2.props.changeSchema(clonedSchema, clonedUISchema, data).then(function () {
            _this2.setState({ isLoading: false, formData: data });
          });
        });
      });
    }
  }, {
    key: 'validate',
    value: function validate(formData, schema, uiSchema) {
      var _props = this.props,
          validate = _props.validate,
          transformErrors = _props.transformErrors;

      var resolvedSchema = (0, _validate.getResolvedShema)(formData, this.props.schema);
      return (0, _validate2.default)(formData, resolvedSchema, validate, transformErrors, initialContext, uiSchema || this.props.uiSchema);
    }
  }, {
    key: 'disableButton',
    value: function disableButton(value) {
      var button = document.querySelector('.form-widget__btn.form-widget__btn-primary');

      if (!button) {
        console.warn('Кнопка не найдена');
        return;
      }

      button.disabled = value;
    }
  }, {
    key: 'refreshAllFields',
    value: function refreshAllFields() {
      for (var fieldId in window.FormsServiceWidget.components) {
        window.FormsServiceWidget.components[fieldId].forceUpdate();
      }
    }
  }, {
    key: 'renderErrors',
    value: function renderErrors(_ref) {
      var cssPrefix = _ref.cssPrefix;
      var _state = this.state,
          status = _state.status,
          flatErrors = _state.flatErrors;


      if (status !== "editing" && flatErrors.length) {
        return _react2.default.createElement(
          'div',
          { className: '\n          ' + cssPrefix + '__panel\n          ' + cssPrefix + '__panel-danger\n          ' + cssPrefix + '__errors\n        ' },
          _react2.default.createElement(
            'div',
            { className: cssPrefix + '__panel-heading' },
            _react2.default.createElement(
              'h3',
              { className: 'panel-title' },
              '\u041E\u0448\u0438\u0431\u043A\u0438:'
            )
          ),
          _react2.default.createElement(
            'ul',
            { className: 'list-group' },
            flatErrors.map(function (error, i) {
              return _react2.default.createElement(
                'li',
                { key: i, className: 'list-group-item text-danger' },
                error
              );
            })
          )
        );
      }

      return null;
    }
  }, {
    key: 'getStateFromProps',
    value: function getStateFromProps(props) {
      var defaultState = (0, _get3.default)(JSONSchemaForm.prototype.__proto__ || (0, _getPrototypeOf2.default)(JSONSchemaForm.prototype), 'getStateFromProps', this).call(this, props);
      defaultState.isLoading = false;
      defaultState.flatErrors = [];
      defaultState.current = 'form';

      if (!this.wasInitiated) {
        this.wasInitiated = true;
      } else {
        delete defaultState.status;
        delete defaultState.formData;
      }

      return defaultState;
    }
  }, {
    key: 'onRequest',
    value: function onRequest(response) {
      var _this3 = this;

      var ok = response.ok;

      /*
      const samplePlainErrors = [
        {
          "errors": [
            "'' is too short",
            "'' is too short",
            "'' is too short"
          ],
          "reason": "ValidationError",
          "message": "123 123",
          "code":
            100002
        }
      ]
       const sampleTargetedErrors = [
        {
          errors: [
            {
              fieldId: "manual_drop_down",
              errorCode: 'dateTimeInvalidDateTimeFuture'
            },
            {
              fieldId: "multi_checkbox_dropdown",
              errorCode: 'filesUploaderTotalFilesCount',
              arguments: {
                argument: '100500'
              }
            },
          ]
        }
      ]
      */

      return response.json().then(function (asJSON) {
        if (ok) {
          _this3.onSuccessRequest(asJSON);
        } else {
          _this3.onErrorRequest(asJSON);
        }
      });
    }
  }, {
    key: 'onSuccessRequest',
    value: function onSuccessRequest(asJSON) {
      var _this4 = this;

      if (!!this.state.uiSchema.onSubmit) {
        this.state.uiSchema.onSubmit(asJSON);
      }

      this.setState({
        isLoading: false,
        flatErrors: []
      }, function () {
        if (!!_this4.props.submitMessage) {
          _this4.setState({
            current: 'success'
          });
        }
      });
    }
  }, {
    key: 'onErrorRequest',
    value: function onErrorRequest(errors) {
      var _this5 = this;

      var flatErrors = [];

      if (!!this.props.onError) {
        this.props.onError(errors);
      }

      for (var groupIndex in errors) {
        var group = errors[groupIndex];

        if (!Array.isArray(group.errors)) {
          if (typeof group === 'string' || group instanceof String) {
            flatErrors.push(_error);
            continue;
          }

          var isCorrect = !!group.errorCode && !!group.fieldId && !!group.arguments;

          if (!isCorrect) {
            continue;
          }

          var _error = group;

          if (!window.FormsServiceWidget.serverErrors[_error.fieldId]) {
            window.FormsServiceWidget.serverErrors[_error.fieldId] = [];
          }

          var errorMessage = _i18next2.default.t('validation:widget.' + _error.errorCode, _error.arguments || {});
          if (errorMessage.indexOf('widget.') === 0) {
            errorMessage = 'Неизвестная ошибка';
          }

          window.FormsServiceWidget.serverErrors[_error.fieldId].push(errorMessage);
        } else {
          for (var errorIndex in group.errors) {
            var _error2 = group.errors[errorIndex];

            if (typeof _error2 === 'string' || _error2 instanceof String) {
              flatErrors.push(_error2);
            } else {
              if (!!_error2.fieldId && !!_error2.errorCode) {
                if (!window.FormsServiceWidget.serverErrors[_error2.fieldId]) {
                  window.FormsServiceWidget.serverErrors[_error2.fieldId] = [];
                }

                var _errorMessage = _i18next2.default.t('validation:widget.' + _error2.errorCode, _error2.arguments || {});
                if (_errorMessage.indexOf('widget.') === 0) {
                  _errorMessage = 'Неизвестная ошибка';
                }

                window.FormsServiceWidget.serverErrors[_error2.fieldId].push(_errorMessage);
              }
            }
          }
        }
      }

      this.setState({
        flatErrors: flatErrors,
        isLoading: false,
        status: 'initial'
      }, function () {
        _this5.forceUpdate();

        for (var fieldId in window.FormsServiceWidget.serverErrors) {
          if (!!window.FormsServiceWidget.components[fieldId]) {
            window.FormsServiceWidget.components[fieldId].forceUpdate();
          }
        }
      });
    }
  }, {
    key: 'renderSuccess',
    value: function renderSuccess(submitMessage, cssPrefix) {
      var _props2 = this.props,
          className = _props2.className,
          noHtml5Validate = _props2.noHtml5Validate;


      return _react2.default.createElement(
        'div',
        { className: '\n          ' + cssPrefix + '__panel\n          ' + cssPrefix + '__panel-success\n        '
        },
        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: submitMessage } }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'button',
            { className: 'form-widget__btn form-widget__btn-primary', onClick: this.resetForm },
            '\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0437\u0430\u043D\u043E\u0432\u043E'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          safeRenderCompletion = _props3.safeRenderCompletion,
          id = _props3.id,
          className = _props3.className,
          name = _props3.name,
          method = _props3.method,
          target = _props3.target,
          action = _props3.action,
          autocomplete = _props3.autocomplete,
          enctype = _props3.enctype,
          acceptcharset = _props3.acceptcharset,
          noHtml5Validate = _props3.noHtml5Validate,
          submitMessage = _props3.submitMessage;
      var _state2 = this.state,
          schema = _state2.schema,
          uiSchema = _state2.uiSchema,
          formData = _state2.formData,
          errorSchema = _state2.errorSchema,
          idSchema = _state2.idSchema;

      var registry = this.getRegistry();
      var cssPrefix = _ramda2.default.path(['formContext', 'cssPrefix'], registry);
      var _SchemaField = registry.fields.SchemaField;

      var successComponent = null;

      if (this.state.current === 'success' && !!submitMessage) {
        successComponent = this.renderSuccess(submitMessage, cssPrefix);
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'form',
          { style: { display: this.state.current === 'success' ? 'none' : '' }, className: className ? cssPrefix + '__' + className : cssPrefix + '__rjsf',
            id: id,
            name: name,
            method: method,
            target: target,
            action: action,
            autoComplete: autocomplete,
            encType: enctype,
            acceptCharset: acceptcharset,
            noValidate: noHtml5Validate,
            onSubmit: this.onSubmit,
            onKeyDown: function onKeyDown(event) {
              var node = event.target;
              if (event.keyCode == 13 && node.type == 'text') {
                event.preventDefault();
              }
            }
          },
          this.renderErrors({ cssPrefix: cssPrefix }),
          _react2.default.createElement(_SchemaField, {
            schema: schema,
            uiSchema: uiSchema,
            errorSchema: errorSchema,
            idSchema: idSchema,
            formData: formData,
            onChange: this.onChange,
            onBlur: this.onBlur,
            registry: registry,
            resetForm: this.resetForm,
            safeRenderCompletion: safeRenderCompletion
          })
        ),
        successComponent
      );
    }
  }]);
  return JSONSchemaForm;
}(_reactJsonschemaForm2.default);

exports.default = JSONSchemaForm;


if (process.env.NODE_ENV !== 'production') {
  JSONSchemaForm.propTypes = {
    schema: _react.PropTypes.object.isRequired,
    uiSchema: _react.PropTypes.object,
    formData: _react.PropTypes.any,
    widgets: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object])),
    fields: _react.PropTypes.objectOf(_react.PropTypes.func),
    ArrayFieldTemplate: _react.PropTypes.func,
    FieldTemplate: _react.PropTypes.func,
    onChange: _react.PropTypes.func,
    onError: _react.PropTypes.func,
    showErrorList: _react.PropTypes.bool,
    onSubmit: _react.PropTypes.func,
    id: _react.PropTypes.string,
    className: _react.PropTypes.string,
    name: _react.PropTypes.string,
    method: _react.PropTypes.string,
    target: _react.PropTypes.string,
    action: _react.PropTypes.string,
    autocomplete: _react.PropTypes.string,
    enctype: _react.PropTypes.string,
    acceptcharset: _react.PropTypes.string,
    noValidate: _react.PropTypes.bool,
    noHtml5Validate: _react.PropTypes.bool,
    liveValidate: _react.PropTypes.bool,
    validate: _react.PropTypes.func,
    transformErrors: _react.PropTypes.func,
    safeRenderCompletion: _react.PropTypes.bool,
    formContext: _react.PropTypes.object,
    validateOnBlur: _react.PropTypes.bool
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/components/Overrided/JSONSchemaForm.js
// module id = 1118
// module chunks = 5